module.exports = __webpack_public_path__ + "static/media/parkAbout.b54c646a.jpg";